import { useLanguage } from "@/core/LanguageContext";
import { LanguageCode } from "@/shared/config/languages";
import { cn } from "@/shared/lib/utils";
import { Select, SelectContent, SelectItem, SelectTrigger } from "@/shared/ui/select";

interface LanguageSelectorProps {
  triggerClassName?: string;
  contentClassName?: string;
}

export function LanguageSelector({ triggerClassName, contentClassName }: LanguageSelectorProps) {
  const { language, setLanguage, availableLanguages } = useLanguage();

  // Don't show selector if only one language is available
  if (availableLanguages.length <= 1) {
    return null;
  }

  const currentLanguage = availableLanguages.find((lang) => lang.code === language);

  return (
    <Select value={language} onValueChange={(val) => setLanguage(val as LanguageCode)}>
      <SelectTrigger className={cn("w-[140px] justify-between", triggerClassName)}>
        <span className="flex min-w-0 items-center gap-2">
          <span>{currentLanguage?.flag}</span>
          <span className="truncate">{currentLanguage?.name || language}</span>
        </span>
      </SelectTrigger>
      <SelectContent className={contentClassName}>
        {availableLanguages.map((lang) => (
          <SelectItem key={lang.code} value={lang.code}>
            <span className="flex items-center gap-2">
              <span>{lang.flag}</span>
              <span>{lang.name}</span>
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
